<template>
  <div class="overlay">
    <div class="contact-form">
      <button class="close-btn" @click="$emit('close')">×</button>
      <h2>Formular de contact</h2>
      <form @submit.prevent="submitForm">
        <input type="text" placeholder="Nume" required />
        <input type="email" placeholder="Email" required />
        <textarea placeholder="Mesaj" rows="4" required></textarea>
        <button type="submit">Trimite</button>
      </form>
      <div class="whatsapp-contact">
        <a href="https://wa.me/40773383914" target="_blank">
          📱 Sau contactează-ne direct pe WhatsApp
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ContactForm",
  methods: {
    submitForm() {
      alert("Formular trimis!");
      this.$emit("close");
    },
  },
};
</script>

<style scoped>
.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.85);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

.contact-form {
  background: #111;
  color: white;
  padding: 2rem;
  border-radius: 16px;
  width: 90%;
  max-width: 500px;
  position: relative;
  box-shadow: 0 0 20px #000;
}

.close-btn {
  position: absolute;
  top: 10px;
  right: 20px;
  font-size: 1.5rem;
  color: white;
  background: none;
  border: none;
  cursor: pointer;
}

form input,
form textarea {
  width: 100%;
  padding: 0.75rem;
  margin-bottom: 1rem;
  border-radius: 8px;
  border: none;
}

form button {
  background-color: white;
  color: black;
  padding: 0.8rem 1.5rem;
  border: none;
  border-radius: 8px;
  font-weight: bold;
  cursor: pointer;
  width: 100%;
}

.whatsapp-contact {
  margin-top: 1rem;
  text-align: center;
}

.whatsapp-contact a {
  color: #25d366;
  font-weight: bold;
  text-decoration: none;
}
</style>
